<template>
<div class="content-main">
    <div class="left-main">
        <div class="left-main-content">
            <div class="title mgt80"><span class="colorFB092B">Cross border</span><span> E-commerce</span></div>
            <!-- <div class="sec-title"><br>
               </div> -->
            <swiper :options="swiperOption">
                <swiper-slide class="swiper-slide text-boxs" v-for="(item,index) in corssList" :key="index">
                    <div class="left-main-box mgt40">
                        <div class="left-main-text">
                            <div class="text-title mgb40">{{item.title}}</div>
                            <div class="texts mgb30">{{item.text}}</div>
                            <div class="btns-box">
                                <div class="btns">More</div>
                            </div>
                        </div>
                        <div class="left-main-imgs">
                            <img :src="item.icon" alt="" width="100%" height="100%">
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
        </div>

    </div>
    <div class="right-main">
        <div class="tagLabel-box">
            <div class="label-top">
                <div :class="{'icon-item':true,'active-icon':item.hasClass}" v-for="(item,index) in list" :key="index" :style="{backgroundImage: `url(${item.hasClass?active_icon:default_icon})`}" @click="changeTag(item)"></div>
            </div>
            <div class="label-bottom">
                <div class="label-bottom-top">
                    <div :class="{'active-child':item.hasClass,'default-child':true}" v-for="(item,index) in list" :key="index" @click="changeTag(item)"></div>
                </div>
                <div class="label-bottom-bottom">
                    <img src="../assets/images/icon_1.png" alt="" width="27px" height="37px">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import top_active from "../assets/images/top_active.png"
import top_default from "../assets/images/top_default.png"
export default {
    name: "tagData",
    props: {
        "vdata": {
            type: Array,
            default: [],
        }

    },
    data() {
        return {
            list: [],
            swiperOption: {
                slidesPerView: 'auto', // 设置slider容器能够同时显示的slides数量; 设置为auto则自动根据slides的宽度来设定数量
                centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左
                spaceBetween: 30,
                //显示分页
                pagination: {
                    el: '.swiper-pagination'
                },
                //设置点击箭头
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                //自动轮播
                //开启循环模式
                loop: false
            },
            corssList: [{
                id: 0,
                title: "Bonded import",
                text: "combined with the construction of cross-border e-commerce collaboration platform, support the collaborative operation of bonded import business, open up the whole chain of account book filing, customs declaration, entry, exit and write off, and realize the integrated customs clearance of bonded goods preparation mode.",
                icon: require("../assets/images/cross-icon.png")
            }, {
                id: 1,
                title: "Cross border payment",
                text: "access to the third-party payment institution with a cross-border payment license, launch cross-border e-commerce online foreign exchange payment business, and provide cross-border collection, payment, settlement and sales of foreign exchange for cross-border e-commerce enterprises.",
                icon: require("../assets/images/corss_2.png")
            }, {
                id: 2,
                title: "Tracking query",
                text: "Provide the online declaration tracking query function of wechat applet, and gradually fill in the enterprise operation support function.",
                icon: require("../assets/images/corss_3.png")
            }],
            btnList: [{
                id: 0,
                icon: require("../assets/images/icon_3.png"),
                text: "综合服务"
            }, {
                id: 0,
                icon: require("../assets/images/icon_4.png"),
                text: "金融服务"
            }, {
                id: 0,
                icon: require("../assets/images/icon_5.png"),
                text: "物流服务"
            }],
            default_icon: top_default,
            active_icon: top_active
        }
    },
    created() {
        let curr = this.vdata;
        let result = [];
        //console.log(curr,"curr")
        curr.forEach((item, index) => {
            if (index % 2 == 0) {
                result.push(item);
            }
        })
        this.list = result;
        console.log(this.list, "vdata")
    },
    methods: {
        changeTag(item) {
            let curr = this.vdata;
            curr.forEach((tem, index) => {
                console.log(tem.id, item.id)
                if (tem.id == item.id) {
                    console.log(11111)
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: true,
                    }
                } else {
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: false,
                    }
                }
            })
            let result = [];
            curr.forEach((item, index) => {
                if (index % 2 == 0) {
                    result.push(item);
                }
            })
            this.list = result;
            this.$emit('godata', {
                item,
                index: item.id
            })
            console.log(curr, "curr")
        }
    }

}
</script>

<style lang="less" scoped>
.active-icon {
    width: 22px !important;
    height: 22px !important;
}

.content-main {
    //background-color: yellowgreen;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .left-main {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        //flex-direction: column;

        .left-main-content {
            width: 1440px;
            height: 100%;
            display: flex;
            flex-direction: column;
            overflow: hidden;

            .swiper-container {
                width: 100%;
                height: 100%;

                .swiper-slide {
                    //width: 400px !important;
                    //border: 1px red solid;
                }

                .swiper-button-next {
                    top: 55% !important;
                    right: 49% !important;
                    color: black;
                    z-index: 10000;
                    width: 32px !important;
                    height: 32px !important;
                }

                .swiper-button-prev {
                    //color:white;
                    top: 55% !important;
                    left: 45% !important;
                    color: black;
                    z-index: 9999;
                    width: 32px !important;
                    height: 32px !important;
                }

                .swiper-button-prev::after {
                    width: 32px !important;
                    height: 32px !important;
                }

                .swiper-button-next:after {
                    width: 32px !important;
                    height: 32px !important;
                }
            }
        }

        .left-main-box {
            display: flex;
            flex: 1;
            //border:1px red solid;
            width: 100%;

            .left-main-text {
                width: 50%;
                height: 240px;
                background: #FFFFFF;
                padding: 80px;
                //border:1px red solid;
            }

            .left-main-imgs {
                width: 50%;
                height: 400px;
                //border:1px red solid;
            }
        }
    }

    .right-main {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        padding-right: 60px;

        //background-color: rgb(167, 164, 164);
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .tagLabel-box {
            width: 40px;
            height: 100%;
            // margin-top: 160px;
            //border: 1px red solid;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;

            .label-top {
                width: 100%;
                height: 30%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;

                //border: 1px green solid;

                .icon-item {
                    width: 8px;
                    height: 8px;
                    background-size: cover;
                    background-position: center center;
                }
            }

            .label-bottom {
                width: 100%;
                height: 30%;
                //border: 1px green solid;

                .label-bottom-top {
                    width: 100%;
                    height: 80%;
                    //border: 1px red solid;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }

                .label-bottom-bottom {
                    width: 100%;
                    height: 20%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    //border:1px red solid;
                }
            }
        }
    }
}

.colorFB092B {
    color: #FB092B;
}

.title {

    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 84px;
}

.sec-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    line-height: 26px;
}

.text-title {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 42px;
}

.texts {
    width: 400px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: justify;
}

.btns {
    width: 118px;
    height: 42px;
    background: #CC1F37;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.btns-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .pages {
        color: #333333;
        font-size: 14px;
    }
}

.mgb40 {
    margin-bottom: 40px;
}

.mgt40 {
    margin-top: 40px;
}

.mgt60 {
    margin-top: 60px;
}

.mgb30 {
    margin-bottom: 30px;
}

.mgb100 {
    margin-bottom: 100px;
}

.mgt80 {
    margin-top: 80px;
}

.mgr10 {
    margin-right: 10px;
}

.btn-go {
    width: 32px;
    height: 32px;
    background-color: #CC1F37;
    margin-top: 40px;
}

.default-child {
    width: 2px;
    height: 16%;
    background: rgba(255, 255, 255, 0.1);
}

.active-child {
    background: rgba(54, 169, 255, 0.5);
}

.color36A9FF {
    color: #36A9FF;
}
</style>



// WEBPACK FOOTER //
// src/components/tagCross.vue